<script setup>
import { Action } from '@seede/renderer/action';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const props = defineProps({
  text: String,
  shortcut: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <TooltipProvider :delayDuration="200">
    <Tooltip>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipContent as-child class="flex gap-2 items-center">
        <div class="flex gap-2 items-center">
          <p>{{ text }}</p>
          <p v-if="shortcut" class="text-sm text-black/40">
            {{ Action.command(shortcut) }}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
